import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const SavingComponent = React.lazy(() => import("../Components/RootComponents/SavingComponent"));
const SavingPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SavingComponent />
      </Suspense>
    </Fragment>
  );
};

export default SavingPage;
